import {
  WithStyles,
  withStyles,
  Button,
  Grid,
} from "@material-ui/core";
import {
  Link,
} from 'react-router-dom';
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles";
import ACLService from '../../acl/services/aclService'
import ContentType from '../components/ContentType'
import Status from '../components/Status'
import Priority from '../components/Priority'
import CR_Date from '../components/CR_Date'
import { isLoggedInUserCenterHead, isLoggedInUserMultiCenterHead } from "../helpers/createContentRequest";
import { Tabs } from "../types/Constants";

interface FiltersContainerProps extends WithStyles<typeof userStyles> {
  activeTab: string
}
interface FiltersContainerState {
  noDataPanel: boolean;
}

class FiltersContainer extends Component<FiltersContainerProps, FiltersContainerState> {
  constructor(props: FiltersContainerProps) {
    super(props);
    this.state = {
      noDataPanel: false
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid className={classes.sideContainer}>
        <CR_Date />
        { (isLoggedInUserCenterHead() || isLoggedInUserMultiCenterHead()) &&
          (this.props.activeTab === Tabs.SentRequest) &&
            <Status />
        }
        <ContentType />
        <Priority />
      </Grid>
    );
  }
}

const mapStateToProps = (state: any) => ({
  activeTab: state.contentRequestReducer.contentRequestReducer.activeTab
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(FiltersContainer));
